// React Imports
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Connected Component
import { connect } from 'react-redux';

// Local Project Components
import Loader from '../global/Loader';

// Actions
import { initializeApp } from '../../actions';

/**
 * Component for initializing the application.
 *
 * This component makes API calls, and sends the user to the correct stage of the application.
 *
 * @component
 * @example
 *
 * return (
 *   <Init />
 * )
 */
class Init extends Component {
  componentDidMount() {
    // Any non-IMS calls to make while we wait.
  }

  async componentDidUpdate() {
    // We've received update from redux state.
    const {
      signedIn,
      history,
      initializeAppAction,
    } = this.props;

    // Signed into Adobe IMS, let's do something with it.
    if (signedIn) {
      initializeAppAction(history);
    }
  }

  render() {
    return (
      <Loader data-test-id="initial-loader" />
    );
  }
}
Init.propTypes = {
  signedIn: PropTypes.bool,
  history: PropTypes.shape({
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    push: PropTypes.func,
  }).isRequired,
  initializeAppAction: PropTypes.func.isRequired,
};

Init.defaultProps = {
  signedIn: null,
};

const mapStateToProps = (state) => ({
  signedIn: state.ims.signedIn,
});

const mapDispatchToProps = {
  initializeAppAction: initializeApp,
};

export default connect(mapStateToProps, mapDispatchToProps)(Init);
